"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeMetadata = exports.writeSchema = void 0;
var core_api_1 = require("@ikegps/core-api");
var writeFields = function (fields) { return fields.map(function (field) { return FieldWriter.write(field); }); };
var BaseFieldWriter = {
    write: function (field) {
        var fieldJSON = {
            name: field.id,
            displayname: field.displayName,
            type: field.type
        };
        if (field.title != null) {
            fieldJSON.title = field.title;
        }
        if (field.subtitle != null) {
            fieldJSON.subtitle = field.subtitle;
        }
        if (field.adminOnly != null) {
            fieldJSON.adminOnly = field.adminOnly;
        }
        if (field.annotationLabelFieldId != null) {
            fieldJSON.annotationLabelFieldId = field.annotationLabelFieldId;
        }
        if (field.clearanceThresholdInMeters != null) {
            fieldJSON.clearanceThresholdInMeters = field.clearanceThresholdInMeters;
        }
        if (field.cloneable != null) {
            fieldJSON.cloneable = field.cloneable;
        }
        if (Array.isArray(field.providers) && field.providers.length > 0) {
            fieldJSON.providers = field.providers;
        }
        if (field.collector != null) {
            fieldJSON.collector = field.collector;
        }
        if (field.required != null) {
            fieldJSON.required = field.required;
        }
        return fieldJSON;
    }
};
var SubFormWriter = {
    TYPE: core_api_1.IkeFieldType.FORM,
    write: function (field) {
        var fieldJSON = BaseFieldWriter.write(field);
        fieldJSON.schema = {
            fields: writeFields(field.fields),
            label: undefined
        };
        if (Array.isArray(field.label) && field.label.length > 0) {
            fieldJSON.schema.label = field.label;
        }
        return fieldJSON;
    }
};
var NestedListWriter = {
    TYPE: core_api_1.IkeFieldType.NESTED_LIST,
    write: function (field) {
        var fieldJSON = BaseFieldWriter.write(field);
        fieldJSON.options = this.writeOptions(field.options);
        return fieldJSON;
    },
    writeOptions: function (options) {
        var _this = this;
        if (options == null) {
            return null;
        }
        return {
            title: options.title,
            values: options.values.map(function (value) {
                var valueJSON = {
                    value: value.value
                };
                if (value.code != null) {
                    valueJSON.code = value.code;
                }
                if (value.color != null) {
                    valueJSON.color = value.color;
                }
                if (value.options != null) {
                    valueJSON.options = _this.writeOptions(value.options);
                }
                return valueJSON;
            })
        };
    }
};
var SelectListWriter = {
    TYPE: core_api_1.IkeFieldType.SELECT_LIST,
    write: function (field) {
        var fieldJSON = BaseFieldWriter.write(field);
        fieldJSON.options = field.options.map(function (_a) {
            var text = _a.text, value = _a.value, color = _a.color;
            return ({ text: text, value: value, color: color });
        });
        return fieldJSON;
    }
};
var FieldWriter = {
    writers: (_a = {},
        _a[SubFormWriter.TYPE] = SubFormWriter,
        _a[NestedListWriter.TYPE] = NestedListWriter,
        _a[SelectListWriter.TYPE] = SelectListWriter,
        _a.DEFAULT = BaseFieldWriter,
        _a),
    getWriter: function (type) {
        return this.writers[type] || this.writers.DEFAULT;
    },
    write: function (field) {
        return this.getWriter(field.type).write(field);
    }
};
var writeSchema = function (fields) {
    return {
        fields: writeFields(fields)
    };
};
exports.writeSchema = writeSchema;
var writeMetadata = function (metadata, fields) {
    if (metadata === null || Object.keys(metadata).length === 0) {
        return undefined;
    }
    var metadataJSON = JSON.parse(JSON.stringify(metadata.options));
    var emptyJSON = JSON.parse('{}');
    if (metadata.import && metadata.import.type != null && metadata.import.version != null) {
        metadataJSON.import = {
            type: metadata.import.type,
            version: metadata.import.version
        };
    }
    var statusFieldId = metadata.statusFieldId;
    if (statusFieldId != null) {
        metadataJSON.status = { field: statusFieldId };
    }
    var mapColorFieldId = metadata.mapColorFieldId;
    if (mapColorFieldId != null) {
        metadataJSON.mapColor = { field: mapColorFieldId };
    }
    if (metadata.hasAddressLookupFields()) {
        metadataJSON.address_lookup = metadata.updateAddressLookupFields(fields);
        if (metadataJSON.address_lookup === null) {
            delete metadataJSON.address_lookup;
        }
    }
    if (JSON.stringify(metadataJSON).localeCompare(JSON.stringify(emptyJSON)) === 0) {
        return undefined;
    }
    return metadataJSON;
};
exports.writeMetadata = writeMetadata;
//# sourceMappingURL=db.v1.write.js.map